import React from 'react'
import styled from 'styled-components'

const StyledGrid = styled.div`
  display: grid;
  frid-template-rows: 1fr;
  grid-gap: 16px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.media.desktop} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(3, 74px);
  }
`
const StyledLanguageCard = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
    0 0 1px 0 rgba(10, 22, 70, 0.06);
  cursor: pointer;
  padding: 16px 16px 16px 24px;
  transition: 250ms;

  ${({ theme }) => theme.media.desktop} {
    &:nth-child(3) {
      margin-left: 16px;
    }

    &:nth-child(4) {
      margin-left: 16px;
    }
  }

  &:hover {
    box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
      0 0 1px 0 rgba(10, 22, 70, 0.06), 0 28px 70px -7px rgba(5, 15, 54, 0.16);
  }
`

const StyledLanguageLogo = styled.img.attrs(({ src }) => ({
  src: src,
}))`
  margin-right: 16px;
`

const StyledLanguageData = styled.div`
  h3 {
    color: ${({ theme }) => theme.colors.greyParagraphColor};
    font-size: 0.875em;
    font-weight: 500;
    line-height: 1.71;
  }

  p {
    color: #8a94a6;
    font-size: 0.75em;
    font-weight: 500;
    line-height: 1.67;
  }
`

const StyledLanguageWrapper = styled.a`
  display: flex;
  justify-content: space-between;
`
const LanguageCards = ({ cmsData }) => {
  const standarizedData = []
  if (cmsData) {
    cmsData.items.map(item => {
      item.fields.id = item.sys.id
      standarizedData.push(item.fields)
      return null
    })
  }
  return (
    <StyledGrid>
      {standarizedData.map(item => {
        return (
          <StyledLanguageCard key={item.id}>
            <StyledLanguageWrapper href={item.link}>
              <StyledLanguageLogo src={item.logo.fields.file.url} />
              <StyledLanguageData>
                <h3>{item.name}</h3>
                <p>{item.type}</p>
              </StyledLanguageData>
            </StyledLanguageWrapper>
          </StyledLanguageCard>
        )
      })}
    </StyledGrid>
  )
}

export default LanguageCards
